// store/modules/loader.js
const state = {
    pendingRequests: 0,
    isLoading: false,
    loadingText: '',
    progress: 0,
    showPercentage: false
};

const mutations = {
    INCREMENT_PENDING_REQUESTS(state) {
        state.pendingRequests++;
        state.isLoading = true;
    },
    DECREMENT_PENDING_REQUESTS(state) {
        state.pendingRequests--;
        state.isLoading = state.pendingRequests > 0;
        if (!state.isLoading) {
            state.progress = 0;
            state.loadingText = '';
            state.showPercentage = false;
        }
    },
    SET_LOADING_TEXT(state, text) {
        state.loadingText = text;
    },
    SET_PROGRESS(state, progress) {
        state.progress = Math.min(Math.max(progress, 0), 100);
        state.showPercentage = true;
    }
};

const getters = {
    isLoading: state => state.isLoading,
    loadingText: state => state.loadingText,
    progress: state => state.progress,
    showPercentage: state => state.showPercentage
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
};